import { render, staticRenderFns } from "./productLibrary.vue?vue&type=template&id=b5e80ade&scoped=true&"
import script from "./productLibrary.vue?vue&type=script&lang=js&"
export * from "./productLibrary.vue?vue&type=script&lang=js&"
import style0 from "./productLibrary.vue?vue&type=style&index=0&id=b5e80ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e80ade",
  null
  
)

export default component.exports